<sirius-modal2 [(open)]="open" [titleId]="titleId" (modalClose)="closeEvent.emit()">
    <div class="sir-content">
        <sirius-heading
            [id]="titleId"
            [text]="'languages.header' | translate"
            textStyleCategory="title"
            textStyleSize="s">
        </sirius-heading>
        <sirius-tab-group #tabgroup [size]="'small'" [topSpacer]="false">
            @for (group of languages().groups; track $index) {
                <sirius-tab [title]="group.name" [active]="tabgroup.currentIndex === $index">
                    <sirius-section>
                        <div class="sir-tab-content">
                            <div class="sir-grid">
                                @for (link of group.links; track $index) {
                                    <a
                                        [href]="link.link.href"
                                        [ngClass]="{
                                            'sir-selected': isItemSelected(link.shortName),
                                        }"
                                        [attr.aria-current]="isItemSelected(link.shortName) ? 'true' : null"
                                        (click)="onLanguageSelect()"
                                        class="sir-country">
                                        <div class="sir-option">
                                            <sirius-icon [name]="link.flag" aria-hidden="true"> </sirius-icon>
                                            <div class="sir-text">
                                                <p class="sir-bold sir-text-style-paragraph-m-bold">
                                                    {{ link.country }}
                                                </p>
                                                <p class="sir-dash" aria-hidden="true">-</p>
                                                <p class="sir-lang">
                                                    {{ link.link.title }}
                                                </p>
                                            </div>
                                            @if (isItemSelected(link.shortName)) {
                                                <sirius-checkmark> </sirius-checkmark>
                                            }
                                        </div>
                                    </a>
                                }
                            </div>
                        </div>
                    </sirius-section>
                </sirius-tab>
            }
        </sirius-tab-group>
    </div>
</sirius-modal2>
